import { useEffect } from 'react';
import { createCanvas } from './helpers';
import css from './ProgressBar.module.scss';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import { checkBrowser } from '../../common/utils/utils';

export default function ProgressBar({ config }) {
    const width = useWindowDimensions();

    useEffect(() => {
        createCanvas(config);
    }, [config, width]);
    return (
        <canvas
            className={css.canvas}
            width={checkBrowser(config.width || 300)}
            height={checkBrowser(config.height || 300)}
            id={config.id}
        ></canvas>
    );
}
